import { AccountBalanceOutlined } from '@mui/icons-material';
import { Button, Typography, styled } from '@mui/material';
import { Column } from 'further-ui/components/Layout';
import { ReactNode } from 'react';

const Icon = styled(AccountBalanceOutlined)(({ theme }) => ({
  fontSize: '100px',
  color: theme.palette.grey[300],
}));

const StyledText = styled(Typography)({
  maxWidth: '230px',
  textAlign: 'center',
});

type Props = {
  text: ReactNode;
  button?: {
    label: string;
    onClick: () => void;
  };
};

const EmptyState: React.FC<Props> = ({ text, button }) => {
  return (
    <Column flex={1} centered spacing="sm" justify="center">
      <Icon color="inherit" />
      <StyledText variant="body2">{text}</StyledText>
      {button ? (
        <Button size="large" variant="contained" onClick={button.onClick}>
          {button.label}
        </Button>
      ) : null}
    </Column>
  );
};

export default EmptyState;
